// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

export const securityHeaderConstants = {
  selectProject: 'Select Project',
  selectOrg: 'Select Org',
  organizationErrorTitle: 'No organization found',
  organizationErrorMsg: 'Error ocurred during fetching organization',
};
